/* eslint import/prefer-default-export: off */
import { URL } from 'url';
import path from 'path';
import fs from 'fs';
import log from 'electron-log';

export function resolveHtmlPath(htmlFileName: string) {
  if (process.env.NODE_ENV === 'development') {
    const port = process.env.PORT || 1212;
    const url = new URL(`http://localhost:${port}`);
    url.pathname = htmlFileName;
    return url.href;
  }
  return `file://${path.resolve(__dirname, '../renderer/', htmlFileName)}`;
}

// 前端buffer转服务端buffer
export function toBuffer (buffer) {
  var buf = new Buffer(buffer.byteLength);
  var view = new Uint8Array(buffer);
  for (var i = 0; i < buf.length; ++i) {
    buf[i] = view[i];
  }
  return buf;
}
// 服务端buffer转Stream
export function bufferToStream (buffer) {
  let stream = new Duplex();
  stream.push(buffer);
  stream.push(null);
  return stream;
}

// 删除其它pcm文件
export function delOtherPCM (filePath:string) {
  try {
    fs.readdirSync(filePath).forEach((file) => {
      let reg = /(.\pcm)$/;
      if (reg.test(file)) {
        fs.unlinkSync(path.resolve(filePath, file));
      }
    })
  } catch (error) {
    Log.error('删除其它pcm文件 错误', error)
  }
}